import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import type { NavItem } from './DashboardLayout';
import './DashboardBottomNav.css';

interface DashboardBottomNavProps {
  navItems: NavItem[];
}

const DashboardBottomNav: React.FC<DashboardBottomNavProps> = ({
  navItems,
}) => {
  const location = useLocation();

  // Mostra max 5 voci nel bottom nav
  const bottomItems = navItems.slice(0, 5);

  return (
    <nav className="dl-bottom-nav" aria-label="Navigazione principale">
      {bottomItems.map((item) => {
        const isActive = item.end
          ? location.pathname === item.path
          : location.pathname.startsWith(item.path);

        return (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.end}
            className={`dl-bottom-item ${isActive ? 'dl-bottom-item--active' : ''}`}
            aria-label={item.label}
          >
            <span className="dl-bottom-icon-wrap">
              <i className={`bi ${item.icon}`} />
              {item.badgeCount != null && item.badgeCount > 0 && (
                <span className="dl-bottom-badge">
                  {item.badgeCount > 9 ? '9+' : item.badgeCount}
                </span>
              )}
            </span>
            <span className="dl-bottom-label">
              {item.labelShort ?? item.label}
            </span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default DashboardBottomNav;
